import {Component, Inject, OnInit} from '@angular/core';
import {GeneralService} from "../../../services/crud/general.service";
import {AlertService} from "../alert/alert.service";
import {ALERT_TYPE} from "../alert/alert.enumerate";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
	selector: 'app-choose-plant-dialog',
	templateUrl: './choose-plant-dialog.component.html',
	styleUrls: ['./choose-plant-dialog.component.scss']
})
export class ChoosePlantDialogComponent implements OnInit
{

	plantList: {name: string, id: string}[] = [];
	selectedPlant: any;
	fromDate: any;
	toDate: any;
	isLoading:boolean = false;


	plantIdMandatory :boolean = true;
	confirmButtonLabel: string = "Confirm";
	allowAllPlants: boolean = false;

	constructor(private generalDataService: GeneralService, public alertService: AlertService, @Inject(MAT_DIALOG_DATA) public data: any)
	{
		if(data.plantIdMandatory){
			this.plantIdMandatory = data.plantIdMandatory;
		}

		if(data.confirmButtonLabel){
			this.confirmButtonLabel = data.confirmButtonLabel;
		}

		if(data.allowAllPlants){
			//this.allowAllPlants = data.allowAllPlants; Disabilitata l'export di tutti i plant, prima capire come gestire a livello di backend
		}
	}

	ngOnInit(): void
	{
		this.isLoading = true;
		//Load the plant for the user according to it's permission
		this.generalDataService.getData("masterdata/plant/selectable-plants").subscribe({
			next: (response : any) =>
			{
				if(response.iResponseCode === 200){
					if(response.oContent){
						if(this.allowAllPlants){
							this.plantList = [{name: "All plants", id: "ALL"}, ...response.oContent]; //If all plants allowed add the entity as first result
						}else{
							this.plantList = response.oContent;
						}

						if(this.plantList.length > 0){
							this.selectedPlant = this.plantList[0].id; //Select first element
						}
					}
				}else{
					this.alertService.add({
						type: ALERT_TYPE.DANGER,
						message: "Some error occurred on plant retrive",
						timeout: 5000,
						selfClose: null
					});
				}
			},
			error: (err) =>
			{
				this.alertService.add({
					type: ALERT_TYPE.DANGER,
					message: "Some error occurred on plant retrive",
					timeout: 5000,
					selfClose: null
				});
			},
			complete: ()=> {
				this.isLoading = false;
			}
		});
	}

	protected readonly webkitURL = webkitURL;
}
